import * as Yup from "yup";

export function initialValues(grade) {
  return {
    name: grade?.name || "",
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
  });
}
